import validationHelper from './validationHelper';

export const MIN_PASSWORD_LENGTH = 6;
export const INVALID_EMAIL_MSG = 'Email is invalid';
export const PASSWORD_TOO_SHORT_MSG = 'attribute too short';

export interface LoginFormValidator {
    email?: string;
    password?: string;
}

export default (formValues: LoginFormValidator) => {
    const errors: LoginFormValidator = {};
    const passwordLength = formValues.password ? formValues.password.length : 0;
    if (!validationHelper.isValidEmail(formValues.email || '')) {
        errors.email = INVALID_EMAIL_MSG;
    }
    if (passwordLength < MIN_PASSWORD_LENGTH) {
        errors.password = PASSWORD_TOO_SHORT_MSG;
    }
    return errors;
};
